import React from 'react';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import styles from './BaseTableCollapseTrigger.module.scss';

export default function BaseTableCollapseTrigger({ handleCollapseClick, isCollapseOpen }) {
  return (
    <div>
      <div className={styles.collapseTrigger} onClick={handleCollapseClick}>
        <span className={styles.test}>{isCollapseOpen ? 'Hide' : 'Show'}</span>
        <span>{isCollapseOpen ? <KeyboardArrowUp/> : <KeyboardArrowDown/>}</span>
      </div>
    </div>
  )
}